module.exports = __webpack_public_path__ + "static/media/Capa-WB43Premium2.8fea6e41.png";